import { CxsBasket } from '../model';

export const isOlderBasket = (previousBasket?: CxsBasket, nextBasket?: CxsBasket): boolean =>
    previousBasket?.basketId === nextBasket?.basketId &&
    ((previousBasket?.lastModifiedDate && !nextBasket?.lastModifiedDate) ||
        (previousBasket?.lastModifiedDate as string) > (nextBasket?.lastModifiedDate as string));
